import LocalState from '../state/LocalState';
import InterceptorName from '../interceptor/InterceptorName';

const checkForInterceptor = (
  name: InterceptorName,
  state: LocalState
): boolean => {
  return state.reporter.interceptors.indexOf(name) > -1;
};
export default checkForInterceptor;
